import { useEffect, useMemo, useState } from 'react';
import { WhatsappWabaAccount } from '../../../hooks/useWhatsappTemplates';
import { WhatsappTemplate } from '../../../types/whatsappTemplates';

type UseWhatsappWabaSelectionArgs = {
  wabaAccounts: WhatsappWabaAccount[];
  getTemplatesForWaba: (wabaId: string) => WhatsappTemplate[];
};

export const useWhatsappWabaSelection = ({ wabaAccounts, getTemplatesForWaba }: UseWhatsappWabaSelectionArgs) => {
  const [selectedWabaId, setSelectedWabaId] = useState<string | null>(null);

  useEffect(() => {
    if (wabaAccounts.length === 0) {
      setSelectedWabaId(null);
      return;
    }

    const isCurrentSelectionValid = selectedWabaId != null && wabaAccounts.some((account) => account.wabaId === selectedWabaId);
    if (!isCurrentSelectionValid) {
      setSelectedWabaId(wabaAccounts[0].wabaId);
    }
  }, [selectedWabaId, wabaAccounts]);

  const selectedWabaTemplates = useMemo(() => {
    if (!selectedWabaId) {
      return [];
    }

    return getTemplatesForWaba(selectedWabaId);
  }, [getTemplatesForWaba, selectedWabaId]);

  return {
    selectedWabaId,
    setSelectedWabaId,
    selectedWabaTemplates,
  };
};
